import { Injectable, Inject } from '@angular/core';
import { Observable, map, switchMap, take } from 'rxjs';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';

import { EnvironmentService } from '@aptitude/environment';
import { WindowService } from '../window.service';

@Injectable({
  providedIn: 'root',
})
export class SubdomainInterceptorService implements HttpInterceptor {
  constructor(
    private environmentService: EnvironmentService,
    private windowService: WindowService,
  ) {}
  private readonly domainRegex = /\w*\.(.*)$/;

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return this.environmentService.environmentData$.pipe(
      take(1),
      map((env) => {
        const requestHasSkipSubdomainRedirectHeader = request.headers.get('Skip-Subdomain-Redirect');
        if (env.useApiSubdomain && !requestHasSkipSubdomainRedirectHeader) {
          request = this.replaceSubDomain(request, env.apiSubDomain);
        }
        return request.clone({
          headers: request.headers.delete('Skip-Subdomain-Redirect'),
        });
      }),
      switchMap((request) => next.handle(request)),
    );
  }

  private replaceSubDomain(
    request: HttpRequest<unknown>,
    newSubdomain: string,
  ) {
    const url = new URL(request.url, this.windowService.window.location.href);

    const splitHost = url.host.split('.');
    // 3 because aptitde.com is 2 and dev.aptitude.com is 3
    const noSubdomain = splitHost.length < 3;
    if (noSubdomain) {
      url.host = `${newSubdomain}.${url.host}`;
    } else {
      splitHost.shift();
      url.host = `${newSubdomain}.${splitHost.join('.')}`;
    }

    return request.clone({
      url: url.toString()
    });
  }
}
